/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import Vue from "vue";
import baseURL from "@/api/http-common";

let userObj =
  localStorage.getItem("telasUserObj") !== null &&
  localStorage.getItem("telasUserObj").length > 0
    ? JSON.parse(localStorage.getItem("telasUserObj"))
    : "";

const assessmentsState = {
  assessmentByUser: {
    assigned: {},
    inProgress: {},
    completed: {},
    combinedReview: {},
  },
  combinedReview: {},
  reassessment: {},
  assessmentDetail: {},
  assessmentQuestions: [],
  pdfLink: {},
};
const getters = {
  // eslint-disable-next-line max-len
  assignedAssessmentMeta: (state) =>
    Object.values(state.assessmentByUser.assigned).map(
      (assessment) => assessment.course_detail.course_detail
    ),
  // eslint-disable-next-line max-len
  inProgressAssessmentMeta: (state) =>
    Object.values(state.assessmentByUser.inProgress).map(
      (assessment) => assessment.course_detail.course_detail
    ),
  // eslint-disable-next-line max-len
  completedAssessmentMeta: (state) =>
    Object.values(state.assessmentByUser.completed).map(
      (assessment) => assessment.course_detail.course_detail
    ),
  getAssessmentUpdateAction: (state) =>
    state.assessmentDetail.action !== undefined
      ? state.assessmentDetail.action
      : "",
  isReportAccreditationMailSent: (state) =>
    state.combinedReview !== undefined &&
    state.combinedReview.report_details.accreditation_email_sent !==
      undefined &&
    state.combinedReview.report_details.accreditation_email_sent === "yes",
  isTestCourse: (state) =>
    state.assessmentDetail.course_detail.course_detail.is_test_course,
};

const actions = {
  async getAssessments({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      const response = await Vue.axios.get(
        `${baseURL}wp/v2/telas-assessment?per_page=100`,
        { params: data }
      );
      const actualData = response.data;
      switch (data.assessmentStatus) {
        case "assigned":
          commit("GETASSIGNEDASSESSMENTS", { actualData, rootState, data });
          break;
        case "in-progress":
          commit("GETINPROGRESSASSESSMENTS", { actualData, rootState, data });
          break;
        case "completed":
          commit("GETCOMPLETEDASSESSMENTS", { actualData, rootState, data });
          break;
        default:
          break;
      }
    } catch (error) {
      if (error.respone.data.length) {
        const actualData = error.response.data;
        commit("GETASSIGNEDASSESSMENTSERROR", {
          actualData,
          rootState,
          origin,
        });
      }
    }
    commit("ENDLOADING", { rootState });
  },
  async updateAssessmentData({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    data.assessment_data = Object.assign({}, data.assessment_data);
    try {
      const response = await Vue.axios.post(
        `${baseURL}extended-telasweb/v1/update-assessment`,
        data
      );
      const actualData = response.data;
      const assessmentAction = data.action;
      commit("UPDATEASSESSMENT", { actualData, rootState, assessmentAction });
    } catch (error) {
      console.log(error);
    }
    commit("ENDLOADING", { rootState });
  },
  async getAssessmentDetail({ commit, rootState }, data) {
    try {
      const assessmentDetailResponse = await Vue.axios.get(
        `${baseURL}wp/v2/telas-assessment/${data.assessmentId}`,
        data
      );
      const actualData = assessmentDetailResponse.data;
      commit("GETASSESSMENTDETAILBYID", { actualData });
    } catch (error) {
      console.log(error);
    }
    commit("ENDLOADING", { rootState });
  },
  async createReport({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      const { userToken } = data;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const createReportArgs = {
        title: `${data.courseTitle}-Report`,
        all_fields: data,
        status: "publish",
      };
      const response = await Vue.axios.post(
        `${baseURL}wp/v2/telas-report`,
        createReportArgs,
        options
      );
      const actualData = response.data;
      commit("REPORTCREATED", { actualData, rootState });
    } catch (error) {
      console.log(error);
    }
    commit("ENDLOADING", { rootState });
  },
  async updateReport({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      const { userToken } = data;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const { reportId } = data;
      delete data.reportId;
      const createReportArgs = {
        report_details: data,
      };
      const response = await Vue.axios.post(
        `${baseURL}wp/v2/telas-report/${reportId}`,
        createReportArgs,
        options
      );
      const actualData = response.data;
      commit("REPORTUPDATED", { actualData, rootState });
    } catch (error) {
      console.log(error);
    }
    commit("ENDLOADING", { rootState });
  },
  async getReportById({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      const { userToken } = data;
      const response = await Vue.axios.get(
        `${baseURL}wp/v2/telas-report/${data.reportId}`,
        {
          params: {},
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      const actualData = response.data;
      commit("REPORTFETCHED", { actualData, rootState });
      return actualData;
    } catch (error) {
      console.log(error);
    } finally {
      // This will ensure ENDLOADING is called regardless of success or failure
      commit("ENDLOADING", { rootState });
    }
  },
  async getAssessmentQuestions({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      // const { userToken } = data;
      const response = await Vue.axios.get(
        `${baseURL}extended-telasweb/v1/assessment-questions`
      );
      const actualData = response.data;
      commit("ASSESSMENTQUESTIONSFETCHED", { actualData });
    } catch (error) {
      console.log(error);
    }
    commit("ENDLOADING", { rootState });
  },
  async updateAssessmentQuestions({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      userObj =
        rootState.user.userDetails.length > 0
          ? rootState.user.userDetails
          : userObj;
      const { userToken } = data;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(
        `${baseURL}extended-telasweb/v1/assessment-questions`,
        data,
        options
      );
      const actualData = response.data;
      commit("ASSESSMENTQUESTIONSFETCHED", { actualData });
    } catch (error) {
      console.log(error);
    }
    commit("ENDLOADING", { rootState });
  },
  async downloadPDF({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      userObj =
        rootState.user.userDetails.length > 0
          ? rootState.user.userDetails
          : userObj;
      const { userToken } = data;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(
        `${baseURL}extended-telasweb/v1/download-pdf`,
        data,
        options
      );
      const actualData = response.data;
      commit("DOWNLOAD_PDF", { actualData });
    } catch (error) {
      console.log(error);
    }
    commit("ENDLOADING", { rootState });
  },
  async removePDF({ commit, rootState }, data) {
    // commit('LOADING', { rootState });
    try {
      userObj =
        rootState.user.userDetails.length > 0
          ? rootState.user.userDetails
          : userObj;
      const { userToken } = data;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(
        `${baseURL}extended-telasweb/v1/remove-pdf`,
        data,
        options
      );
      const actualData = response.data;
      commit("REMOVE_PDF", { actualData });
    } catch (error) {
      console.log(error);
    }
    // commit('ENDLOADING', { rootState });
  },
};

const mutations = {
  GETASSIGNEDASSESSMENTS(state, { actualData, rootState, data }) {
    assessmentsState.assessmentByUser.assigned = actualData;
  },
  GETINPROGRESSASSESSMENTS(state, { actualData, rootState, data }) {
    assessmentsState.assessmentByUser.inProgress = actualData;
  },
  GETCOMPLETEDASSESSMENTS(state, { actualData, rootState, data }) {
    console.log(actualData, data);
    assessmentsState.assessmentByUser.completed = actualData;
  },
  UPDATEASSESSMENT(state, { actualData, rootState, assessmentAction }) {
    assessmentsState.assessmentDetail = actualData;
    assessmentsState.assessmentDetail.action = assessmentAction;
  },
  GETASSESSMENTDETAILBYID(state, { actualData }) {
    assessmentsState.assessmentDetail = actualData;
  },
  REPORTCREATED(state, { actualData, rootState }) {
    assessmentsState.combinedReview = actualData;
  },
  REPORTFETCHED(state, { actualData, rootState }) {
    assessmentsState.combinedReview = actualData;
  },
  REPORTUPDATED(state, { actualData, rootState }) {
    assessmentsState.combinedReview = actualData;
  },
  ASSESSMENTQUESTIONSFETCHED(state, { actualData }) {
    assessmentsState.assessmentQuestions = { ...actualData };
  },
  UPDATEASSESSMENTQUESTIONS(state, { actualData }) {
    const { tabIndex } = actualData;
    const { currentStep } = actualData;
    const { steps } = actualData;
    const { updating } = actualData;
    const { questionIndex } = actualData;
    const { headingText } = actualData;
    const { questionText } = actualData;
    const { adminOnly } = actualData;
    const { newHeadingQuestion } = actualData;
    const { newQuestion } = actualData;
    const { domainScoreKey } = actualData;
    const { domainScoreValue } = actualData;
    const { newDomainValue } = actualData;
    const { subTitleText } = actualData;
    switch (updating) {
      case "editSubTitle":
        Vue.set(steps[currentStep], "subTitle", subTitleText);
        Vue.set(steps[currentStep], "editing", false);
        break;
      case "editSubtitleTrigger":
        Vue.set(steps[currentStep], "editing", true);
        break;
      case "editHeading":
        Vue.set(steps[currentStep].content[tabIndex], "heading", headingText);
        Vue.set(steps[currentStep].content[tabIndex], "editing", false);
        break;
      case "editHeadingTrigger":
        Vue.set(steps[currentStep].content[tabIndex], "editing", true);
        break;
      case "editQuestionTrigger":
        Vue.set(
          steps[currentStep].content[tabIndex].questions[questionIndex],
          "editing",
          true
        );
        break;
      case "editQuestion":
        Vue.set(
          steps[currentStep].content[tabIndex].questions[questionIndex],
          "question",
          questionText
        );
        Vue.set(
          steps[currentStep].content[tabIndex].questions[questionIndex],
          "editing",
          false
        );
        break;
      case "editAdminOnly":
        Vue.set(
          steps[currentStep].content[tabIndex].questions[questionIndex],
          "adminOnly",
          adminOnly
        );
        break;
      case "deleteHeading":
        steps[currentStep].content.splice(tabIndex, 1);
        break;
      case "deleteQuestion":
        steps[currentStep].content[tabIndex].questions.splice(questionIndex, 1);
        break;
      case "addHeadingQuestion":
        const newHeadingObj = {
          adminOnly: false,
          domainScore: {
            0: "Yes",
            1: "Yes But",
            2: "No But",
            3: "No",
          },
          heading: newHeadingQuestion,
          questions: [],
        };
        steps[currentStep].content.push(newHeadingObj);
        break;
      case "addQuestion":
        const newQuestionObj = {
          adminOnly: false,
          options: ["Yes", "Yes But", "No But", "No"],
          question: newQuestion,
        };
        steps[currentStep].content[tabIndex].questions.push(newQuestionObj);
        break;
      case "updateDomain":
        delete steps[currentStep].content[tabIndex].domainScore[domainScoreKey];
        Vue.set(
          steps[currentStep].content[tabIndex].domainScore,
          newDomainValue,
          domainScoreValue
        );
        // steps[currentStep].content[tabIndex].domainScore[newDomainValue] = domainScoreValue;
        break;
      default:
        break;
    }
  },
  LOADING(state, { rootState }) {
    rootState.common.loading = true;
  },
  ENDLOADING(state, { rootState }) {
    rootState.common.loading = false;
  },
  DOWNLOAD_PDF(state, { actualData }) {
    state.pdfLink = actualData;
  },
  REMOVE_PDF(state, { actualData }) {
    state.pdfLink = {};
  },
};

export default {
  namespaced: true,
  state: assessmentsState,
  getters,
  actions,
  mutations,
};
